import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left',
    color: ({ dark }) =>
      `${dark ? theme.palette.secondary.main : theme.palette.text.secondary}`,
    fontSize: 14,
    fontFamily: ({ bold }) => `${bold ? 'CircularMed' : 'Circular'}`,
    textTransform: ({ uppercase }) => `${!uppercase && 'none'}`,
    [theme.breakpoints.up('md')]: {
      lineHeight: 1.2,
      fontSize: 16,
      color: ({ highlighted }) =>
        `${
          !highlighted
            ? theme.palette.text.secondary
            : theme.palette.text.primary
        }`
    }
  }
}));

const NavLinkLabel = ({ highlighted, children, bold, uppercase, dark }) => {
  const classes = useStyles({ highlighted, bold, uppercase, dark });
  return <Typography classes={classes}>{children}</Typography>;
};

NavLinkLabel.defaultProps = {
  fullWidth: false
};
NavLinkLabel.propTypes = {
  highlighted: PropTypes.bool,
  classes: PropTypes.shape({}),
  children: PropTypes.node,
  bold: PropTypes.bool,
  uppercase: PropTypes.bool,
  dark: PropTypes.bool
};

export default NavLinkLabel;
